export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            投稿、合作或反馈建议，欢迎随时联系
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/60 p-6 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-center">
            <div className="p-4">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-1">投稿邮箱</h3>
              <p className="text-sm text-foreground-500">contact@mimei.com</p>
            </div>
            <div className="p-4">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-3">
                <i className="ri-wechat-line text-xl"></i>
              </div>
              <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-1">官方微信</h3>
              <p className="text-sm text-foreground-500">谜妹漫画官方号</p>
            </div>
            <div className="p-4">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-3">
                <i className="ri-question-answer-line text-xl"></i>
              </div>
              <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-1">反馈建议</h3>
              <p className="text-sm text-foreground-500">直接留言或发送邮件</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}